module.exports = __webpack_public_path__ + "static/media/JunctionX_logos_white.154b43c3.png";